// gql/queries/useGetEventPerformance.js
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

// V2: figures come from purchase_ledger; profit is platform fee minus the
// house Stripe estimate (3.25% + 30c per app charge, 10c per POS card charge).
export const GET_EVENT_PERFORMANCE = gql`
  query GetEventPerformanceTable($input: GetEventPerformanceInput!) {
    getEventPerformanceV2(input: $input) {
      event_id
      event_name
      date
      app_sales
      pos_card_sales
      pos_cash_sales
      app_profit
      pos_profit
      total_profit
    }
  }
`;

export function useGetEventPerformance(account_id, year) {
  const { data, loading, error } = useQuery(GET_EVENT_PERFORMANCE, {
    variables: { input: { account_id, year } },
    fetchPolicy: 'no-cache',
    skip: !account_id || !year,
  });

  return { data, loading, error };
}
